import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { EPhotos } from 'src/app/classes/def/app/icons';
import { Platform } from '@ionic/angular';
import { ThemeColors } from 'src/app/classes/def/app/theme';
import { Messages } from 'src/app/classes/def/app/messages';
import { EAlertButtonCodes } from 'src/app/classes/def/app/ui';
import { UiExtensionService } from 'src/app/services/general/ui/ui-extension';
import { BackButtonService } from 'src/app/services/general/ui/back-button';
import { SettingsManagerService } from 'src/app/services/general/settings-manager';
import { INavParams, IViewSpecs } from 'src/app/classes/def/nav-params/general';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { ERouteDef } from 'src/app/app-utils';
import { ENavParamsResources } from 'src/app/classes/def/nav-params/resources';
import { NavParamsService } from 'src/app/services/app/nav-params';
import { StoryDataService } from 'src/app/services/data/story';
import { IMarketplaceDetailNavParams } from 'src/app/classes/def/nav-params/marketplace';

@Component({
  selector: 'app-dispatch',
  templateUrl: './dispatch.page.html',
  styleUrls: ['./dispatch.page.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DispatchPage implements OnInit, OnDestroy {
  theme: string = "theme-light theme-light-bg";
  logoSrc: string = EPhotos.leplaceLogo;
  backgroundSrc: string = EPhotos.home;
  backgroundLoaded: boolean = false;
  vs: IViewSpecs;
  loading: boolean = true;

  constructor(
    public plt: Platform,
    public uiext: UiExtensionService,
    public backButton: BackButtonService,
    public settingsProvider: SettingsManagerService,
    public router: Router,
    public route: ActivatedRoute,
    public nps: NavParamsService,
    public storyData: StoryDataService
  ) {
    this.plt.ready().then(() => {

      this.settingsProvider.getSettingsLoaded(false).then((res) => {
        if (res) {
          this.theme = ThemeColors.theme[SettingsManagerService.settings.app.settings.theme.value].css;
        }
      }).catch((err: Error) => {
        console.error(err);
      });

      this.backButton.replace(() => {
        if (!this.uiext.isAlert()) {

          this.uiext.showAlert(Messages.msg.exit.before.msg, Messages.msg.exit.before.sub, 2, null, false).then((res: number) => {
            if (res === EAlertButtonCodes.ok) {
              this.backButton.exitApp();
            }
          }).catch(() => {
          });
        }
      });

    }).catch((err: Error) => { console.error(err); });
  }


  ngOnInit() {
    console.log('ion view will enter ' + new Date().getTime());
    console.log("in dispatch");
    const fullPath = this.router.url;
    this.dispatch(fullPath);
  }

  dispatch(url: string) {
    // match storyline links
    // const match = url.match(/storyline\/([^\/]+)/);
    const match = url.match(/storyline-([^\/]+)/);
    if (url === "/") {
      this.redirectHome();
      return;
    }
    if (!match) {
      // redirect to home page
      this.uiext.showAlertNoAction(Messages.msg.linkNotFound.after.msg, Messages.msg.linkNotFound.after.sub, false);
      this.redirectHome();
    } else {
      let vurl: string = match ? match[1] : null;
      console.log("detected url: ", vurl);
      let vurlTok: string[] = vurl.split("?");
      vurl = vurlTok[0];
      let vurlParams: string = vurlTok.length > 1 ? vurlTok[1] : null;
      console.log("params: " + vurlParams);
      let vurlParamsExtracted = new URLSearchParams(vurlParams);
      console.log("params extracted: ", vurlParamsExtracted.toString());

      // check back end for linked storyline page
      this.storyData.getStoryConnectLink(vurl).then((connectURL: string) => {
        if (connectURL != null) {
          try {
            const urlParams = new URLSearchParams(new URL(connectURL).search);
            let storyId: number = Number.parseInt(urlParams.get("storyId"));
            let token: string = urlParams.get("token");
            let isToken: boolean = false;
            let tokenSignature: string = "token-";
            if (token.indexOf(tokenSignature) !== -1) {
              token = token.slice(tokenSignature.length - 1);
              isToken = true;
            }

            let params: IMarketplaceDetailNavParams = {
              storyId: storyId,
              token: token,
              standalone: true,
              reload: true,
              var: !isToken
            };
            let qparams: any = {
              storyId: storyId,
              token: token,
              var: true
            };

            if (vurlParamsExtracted != null) {
              let nocheckout: boolean = vurlParamsExtracted.get("nocheckout") === "true";
              if (nocheckout) {
                params.nocheckout = nocheckout;
                qparams.nocheckout = nocheckout;
              }
            }

            let navParams: INavParams = {
              view: null,
              storyId: storyId,
              token: token,
              params: params
            };

            console.log("redirect query params: ", qparams);
            this.nps.set(ENavParamsResources.marketplaceContent, navParams);
            let extras: NavigationExtras = {
              replaceUrl: true,
              queryParams: qparams
            };
            this.router.navigate([ERouteDef.storyline], extras).then(() => {
            }).catch((err: Error) => {
              console.error(err);
            });
          } catch (err) {
            console.error(err);
            this.uiext.showAlertNoAction(Messages.msg.linkNotFound.after.msg, Messages.msg.linkNotFound.after.sub, false);
            this.redirectHome();
          }
        } else {
          this.redirectHome();
        }
      }).catch((err: Error) => {
        console.error(err);
        this.uiext.showAlertNoAction(Messages.msg.linkNotFound.after.msg, Messages.msg.linkNotFound.after.sub, false);
      });
      this.loading = false;
    }
  }

  redirectHome() {
    let navParams: INavParams = {
      view: null,
      params: null
    };
    this.nps.set(ENavParamsResources.home, navParams);
    this.router.navigate([ERouteDef.home], { replaceUrl: true }).then(() => {
    }).catch((err: Error) => {
      console.error(err);
    });
  }

  ngOnDestroy() {
    console.log("ion view will leave " + new Date().getTime());
    // if (this.periodic) {
    //   clearTimeout(this.periodic);
    //   this.periodic = null;
    // }
  }

}

